<script setup lang="ts">
import { usePage } from "@inertiajs/vue3"
import { computed } from "vue"

import { Alert } from "@/components/ui/alert"

const visible = computed(() => {
  const page = usePage()
  return page.props.env !== "prod"
})
</script>

<template>
  <Alert v-if="visible" variant="warning" class="progress-team-hint">
    <slot />
  </Alert>
</template>
